const WORKLOG_DEPLOY_SUFFIX = 'worklog.kadellabs.com';

function isWorklogDeployHost(hostname) {
  return String(hostname || '')
    .trim()
    .toLowerCase()
    .endsWith(WORKLOG_DEPLOY_SUFFIX);
}

/**
 * Resolve API base URL for fetch calls.
 *
 * - Empty / unset REACT_APP_BACKEND_URL → same-origin relative paths (/api/...) via CRA dev
 *   proxy (local) or nginx reverse proxy (deployed).
 * - On uat.worklog.kadellabs.com / worklog.kadellabs.com always use same-origin — nginx proxies /api.
 * - If env points at the same hostname as the SPA (e.g. :8001 on worklog host), use relative paths.
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL;
  if (raw == null) return '';

  const trimmed = String(raw).trim();
  if (!trimmed || trimmed === 'undefined') return '';

  const withoutTrailingSlash = trimmed.replace(/\/+$/, '');

  if (typeof window !== 'undefined' && window.location?.hostname) {
    if (isWorklogDeployHost(window.location.hostname)) {
      return '';
    }
  }

  if (typeof window === 'undefined' || !window.location?.hostname) {
    return withoutTrailingSlash;
  }

  try {
    const base = withoutTrailingSlash.startsWith('http')
      ? withoutTrailingSlash
      : `${window.location.protocol}//${withoutTrailingSlash}`;
    const configured = new URL(base);

    if (configured.hostname === window.location.hostname) {
      return '';
    }
  } catch {
    // Malformed env — fall through to literal value
  }

  return withoutTrailingSlash;
}

export function buildApiUrl(endpoint) {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const base = getApiBaseUrl();
  return base ? `${base}${path}` : path;
}
